<div class="alert alert-info alert-dismissible fade show" role="info" *ngIf="message != ''">
    <strong>{{message}}</strong>
    <button type="button" class="close" data-dismiss="info" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>


<mat-card [style.max-width]="isMobileView ? '400px' : '800px'">
    <h2 style="font-family: Roboto; font-style: normal; font-weight: bold; font-size: 245%;">{{actualDate | date:'y MMMM
        dd'}}.</h2>
    <mat-card-content *ngFor="let post of posts" [style.opacity]="post.solved ? '0.5' : '1'">
        <mat-divider></mat-divider>
        <mat-list>
            <div class="left" style="font-family: Roboto; font-style: normal; font-weight: bold;">Megrendelő:</div>
            <div class="right">{{post.customer}}</div>
            <br>
            <div class="left" style="font-family: Roboto; font-style: normal; font-weight: bold;">Hová:</div>
            <div class="right">{{post.toLocation}}</div>
            <br>
            <div class="left" style="font-family: Roboto; font-style: normal; font-weight: bold;">Időpont:</div>
            <div class="right">{{post.hour}}</div>
            <br>
            <div class="left" style="font-family: Roboto; font-style: normal; font-weight: bold;">Rendszámok:</div>
            <div class="right">{{post.licensePlateNumbers}}</div>
            <br>
            <div class="buttons-up">
                <button class="dml-button" style="float: left;" mat-raised-button color="primary"
                    (click)="openDialog(post)">Részlet</button>
                <div class="divider"></div>
                <button class="dml-button" mat-raised-button color="primary" (click)="toModify(post.postId)"
                    [disabled]="post.solved">Módosítás</button>
                <div class="divider"></div>
                <button class="dml-button" style="padding-left: 0px;  float:right;" mat-raised-button color="warn"
                    (click)="deletePostConfirm(post.postId)">Törlés</button>
            </div>
            <div class="buttons-down">
             <!--   <button style="height: 10%; width: 31.8%;  " class="left" mat-raised-button
                    (click)="changePriorUp(post.postId, post.date)">Fel</button> -->
                <div class="divider"></div>
                <button style="height: 10%; width: 31.8%; color:green;" mat-raised-button (click)="solvePostConfirm(post.postId)"
                    [disabled]="post.solved">Teljesítve</button>
                <div class="divider"></div>
             <!--     <button class="right" style="height: 10%; width: 31.8%;  " mat-raised-button
                    (click)="changePriorDown(post.postId, post.date)">Le</button>  -->
            </div> 
        </mat-list>
    </mat-card-content>
    <mat-divider></mat-divider>
    <br>
    <button mat-raised-button color="primary" (click)="toCreate()">Új rögzítés</button>
    <div class="divider"></div>
    <button mat-raised-button color="primary" [routerLink]="['/calendar']">Vissza</button>
</mat-card>